import { BACKEND_URL } from "../url/Url";

const VEHICULE_BASE = `${BACKEND_URL}/gestion-vehicule/`;

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const VehiculeMissionService = {
  all: async () => {
    try {
      const response = await fetch(`${VEHICULE_BASE}vehicules-en-missions`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();

        // Parcourir les missions pour récupérer les missionnaires associés
        const missionsWithMissionaires = await Promise.all(
          result.data.map(async (vehicule) => {
            const missionaireResponse = await VehiculeMissionService.missionnaires(vehicule.id_mission);
            if (missionaireResponse.success) {
              // Concaténer les codes des missionnaires avec une virgule
              const missionnairesCodes = missionaireResponse.data.map(m => m.code).join(', ');
              vehicule.missionnaires = missionnairesCodes;
            } else {
              vehicule.missionnaires = '';
            }
            return vehicule;
          })
        );
        return {
          status: 200,
          message: "OK",
          data: missionsWithMissionaires,
          error: null
        };
      } else {
        const errorData = await response.json();
        return { status: response.status, message: errorData.message, data: [], error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des véhicules en mission:', error);
      return { status: 500, message: 'Erreur serveur', data: [], error: error.message };
    }
  },

  missionnaires: async (id_mission) => {
    try {
      const response = await fetch(`${VEHICULE_BASE}vehicule-en-mission/missionnaires/${id_mission}`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result.data };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des missionnaires:', error);
      return { success: false, error: error.message };
    }
  },

  add: async (vehiculeData) => {
    try {
      console.log(vehiculeData);
      const response = await fetch(`${VEHICULE_BASE}vehicule-en-mission/ajout/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(vehiculeData),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout du véhicule:', error);
      return { success: false, error: error.message };
    }
  },

  update: async (id_vehicule, vehiculeData) => {
    const userID =parseInt(localStorage.getItem('userId'));
    const payload = {
      data: vehiculeData,
      user_id: userID
    };
    console.log("Payload:", payload);

    try {
      const response = await fetch(`${VEHICULE_BASE}vehicule-en-mission/modification/${id_vehicule}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du véhicule:', error);
      return { success: false, error: error.message };
    }
  },

  delete: async (id_vehicule) => {
    try {
      const response = await fetch(`${VEHICULE_BASE}vehicule-en-mission/suppression/${id_vehicule}/${localStorage.getItem('accessToken')}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du véhicule:', error);
      return { success: false, error: error.message };
    }
  },

  getById: async (id_vehicule) => {
    try {
      const response = await fetch(`${VEHICULE_BASE}${id_vehicule}/`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);

        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du véhicule:', error);
      return { success: false, error: error.message };
    }
  },


};

export default VehiculeMissionService;
